module.exports = __webpack_public_path__ + "img/exchange-1-zh-m.229a5e24.png";